<template lang="pug">
    div
        Select(@on-change="selectExample")
            Option(
                v-for="(scroll, index) in examples"
                :value="index"
                :label="scroll.scrollName"
                :key="index"
            )
</template>

<script>
import dedent from "dedent";
import all_in_one from "./templates/all_in_one.json";
import bus from "@/libs/bus.js";
export default {
    name: "ScrollsExample",
    components: {},
    props: {
        selectFileData: { type: Object },
        formData: { type: Object },
    },
    data() {
        return {
            examples: [
                {
                    scrollName: "send_html",
                    minioCodeEditer: [
                        {
                            path: "send_html/index.js",
                            type: "",
                            content: dedent`
                                module.exports = (req, res, next) => {
                                    let headers = { "Content-Type": "text/html; charset=UTF-8" }
                                    let body = '<p>Hello Ninja</p>'

                                    res.headers(headers).send(body)
                                };
                            `,
                        },
                    ],
                },
                {
                    scrollName: "send_json",
                    minioCodeEditer: [
                        {
                            path: "send_json/index.js",
                            type: "",
                            content: dedent`
                                module.exports = (req, res, next) => {
                                    let headers = { "Content-Type": "Application/json" }
                                    let body = { "hello": "ninja" }

                                    res.headers(headers).send(body)
                                };
                            `,
                        },
                    ],
                },
                {
                    scrollName: "redirect",
                    minioCodeEditer: [
                        {
                            path: "redirect/index.js",
                            type: "",
                            content: dedent`
                                module.exports = (req, res, next) => {
                                    let status = '301'
                                    let headers = { "Location": "https://google.com/" }

                                    res.status(status).headers(headers).send()
                                }
                            `,
                        },
                    ],
                },
                {
                    scrollName: "fetch_url",
                    minioCodeEditer: [
                        {
                            path: "fetch_url/index.js",
                            type: "",
                            content: dedent`
                                module.exports = (req, res, next) => {
                                    const https = require("https");
                                    const url = "https://catfact.ninja/fact";

                                    https
                                        .get(url, resp => {
                                            let data = "";

                                            resp.on("data", chunk => {
                                                data += chunk;
                                            });

                                            resp.on("end", () => {
                                                let headers = { "Content-Type": "Application/json" }
                                                let body = data

                                                res.headers(headers).send(body)
                                            });
                                        })
                                        .on("error", err => {
                                            let status = '409'
                                            let headers = { "Content-Type": "Application/json" }
                                            let body = data

                                            res.status(status).headers(headers).send(body)
                                        });
                                };
                            `,
                        },
                    ],
                },
                {
                    scrollName: "set_headers_to_origin",
                    minioCodeEditer: [
                        {
                            path: "set_headers_to_origin/index.js",
                            content: dedent`
                                module.exports = (req, res, next) => {
                                    let headers = Object.assign({}, req.headers, { "X-Request-Time": new Date() })

                                    req.headers = headers
                                    next();
                                }
                            `,
                        },
                    ],
                },
                {
                    scrollName: "all_in_one",
                    minioCodeEditer: all_in_one.map((e) => {
                        e.type = "";
                        return e;
                    }),
                },
            ],
        };
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        selectExample(index) {
            bus.$emit("selectExample", this.examples[index]);
            // this.$emit("selectExample", this.examples[index]);
        },
    },
    computed: {},
    beforeDestroy() {},
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Scrolls/ScrollsExample.vue